<template>
  <div class="content-main">
    <section id="testimonials">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title-index">
            <h2>Comentários de quem usa o eSUS Feedback</h2>
          </div>
        </div>
        <splide :options="optionsSplide" :slides="comentarios">
          <splide-slide v-for="item in comentarios" :key="item.foto_nome">
            <div class="slide-item-media">
              <div
                class="slide-item-img"
                v-bind:style="{
                  backgroundImage:
                    'url(https://esusfeedback.com.br/esus-feedback-admin/config/uploads/' +
                    item.foto_nome +
                    ')'
                }"
              ></div>
              <div class="slide-item-media-info">
                <h3>{{ item.nome }}</h3>
                <span><i class="icofont-star"></i> {{ item.funcao }}</span>
                <br />
                <span
                  ><i class="icofont-google-map"></i> {{ item.cidade }}</span
                >
                <br />
                <span
                  ><i class="icofont-instagram"></i> {{ item.instagram }}</span
                >
              </div>
            </div>
            <div class="slide-item-content">
              <p>{{ item.comentario }}</p>
            </div>
          </splide-slide>
        </splide>
      </div>
    </section>
  </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css'

export default {
  name: 'Avaliacoes',
  components: {
    Splide,
    SplideSlide
  },
  mounted() {
    this.buscarComentarios()
  },
  data() {
    return {
      comentarios: [],
      optionsSplide: {
        rewind: true,
        width: 1140,
        perPage: 1,
        gap: '1rem',
        breakpoints: {
          '640': {
            perPage: 1,
            gap: '1rem',
            width: 360
          },
          '480': {
            perPage: 1,
            gap: '1rem',
            width: 360
          },
          '768': {
            perPage: 1,
            gap: '1rem',
            width: 768
          }
        }
      },
      cardsSplide: {
        rewind: true,
        autoplay: true,
        width: 1170,
        perPage: 1,
        gap: '0.6rem',
        breakpoints: {
          '640': {
            perPage: 1,
            gap: '1rem',
            width: 360
          },
          '480': {
            perPage: 1,
            gap: '1rem',
            width: 360
          }
        },
        arrows: false
      }
    }
  },
  methods: {
    buscarComentarios() {
      this.$apiPublic
        .get('/buscar-comentarios-login')
        .then(response => {
          this.comentarios = response.data
        })
        .catch(function(error) {
          console.log(error)
        })
    }
  }
}
</script>

<style>
#testimonials {
  margin-top: 0px;
}

.splide--slide {
  margin: 0 auto;
  width: 100% !important;
}

.splide__slide {
  margin-bottom: 60px;
}

.splide__slide img {
  width: 100%;
}

.slide-item-img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border: 2px solid #ddd;
  border-radius: 50%;
  height: 110px;
  padding: 2px;
  width: 110px;
}

.slide-item-content h3 {
  text-align: center;
  font-size: 18px;
  margin-top: 10px;
}

.slide-item-content span {
  text-align: center;
  font-size: 12px;
  display: block;
}

.slide-item-content p {
  color: #8d959d;
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  line-height: 25px;
  margin: 0 60px;
  position: relative;
  text-align: center;
}

.slide-item-content p:before {
  content: '\275D';
  position: absolute;
  left: 5px;
  top: -15px;
  font-size: 35px;
}

.slide-item-media {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.slide-item-media-info {
  margin-left: 20px;
}

.slide-item-media-info h3 {
  font-size: 22px;
  margin-bottom: 0;
}
</style>
